import { Component, Input, Output, EventEmitter } from '@angular/core';

import { InspectionSection } from '../../../shared/models/index';

@Component({
    selector: 'addpoint-sections',
    templateUrl: './section-list.component.html',
    standalone: false
})
export class AddPointSectionListComponent {
  @Input() public sections: InspectionSection[];
  @Output() public toggleSelectSection: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}

  public selectSection(section: InspectionSection) {
    this.toggleSelectSection.emit(section);
  }
}
